import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';
import { validateSkillsSearch } from '../lib/skills-search.js';

// Lazy so the Skills bundle stays out of the entry chunk and is never fetched
// while the sidebar keeps the surface hidden.
const SkillsPage = React.lazy(() =>
  import('../components/skills/page.js').then((module) => ({ default: module.SkillsPage })),
);

// Shared by both the top-level and the workspace-scoped route so they serve the
// same page; workspace context comes from the existing providers above them.
export function SkillsRouteComponent() {
  return (
    <React.Suspense fallback={null}>
      <SkillsPage />
    </React.Suspense>
  );
}

export const Route = createFileRoute('/skills')({
  component: SkillsRouteComponent,
  validateSearch: validateSkillsSearch,
});
